// extracted by mini-css-extract-plugin
export default {"role_picture":"RolePicture_role_picture__iBhyH"};